<!-- Compiled at 2026-09-18T12:45:23.821Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<Orders-MainLayout
					[$formDirective]="$formDirective"
					[$disabled]="$disabled"
					[$ignoreValidations]="$ignoreValidations"
					[screenTitle]="'Customer requests'"
					[isForExternalUser]=""
				>
					<ng-template
						data-content-area="top-right"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<ng-container *lowgileScope="null; screen: this; let $scope">
							<div
								data-content-area="top-right"
								data-defined-in="Orders.CustomerRequestList"
							></div>
						</ng-container>
					</ng-template>

					<ng-template
						data-content-area="content"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<ng-container *lowgileScope="null; screen: this; let $scope">
							<div
								data-content-area="content"
								data-defined-in="Orders.CustomerRequestList"
							>
								<lowgile-table
									#datatable_100
									[serverDataStore]="Orders.Db"
									[trackBy]="trackByAutomatic"
									[filter]="screen.filter"
									[entity]="Orders.CustomerRequestItem"
									[columns]="_DataTableBlock_columns_100(screen)"
									[showSettings]="true"
									[userDefinedConfiguration]="undefined"
									[usePaging]="true"
									[pageSize]="20"
									[pageSizeOptions]="[10, 20, 50]"
									[useGlobalFilter]="true"
									[debouncingDelay]="250"
									[stickyHeader]="true"
									[additionalFindOptions]="_DataTableBlock_additionalFindOptions_100({ app, screen, $pathSegments, $disabled })"
									[additionalHeaderRows]="[]"
									[additionalFooterRows]="[]"
									[allClasses]="$Modules"
									[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
									[surroundingScope]="$scope"
									#$table_100="lowgileTable"
								>
									<ng-container [lowgile-column]="'requestId'">
										<th mat-header-cell *matHeaderCellDef>
											<span
												[innerHtml]="'Request ID' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
										</th>
										<td
											mat-cell
											*matCellDef="let item; let index = index"
											[attr.data-label]="'Request ID'"
										>
											<ng-container
												*lowgileScope="item; as: 'item'; let $scope"
											>
												<ng-container
													*lowgileScope="index; as: 'index'; let $scope"
												>
													<a
														routerLink="/CustomerRequestView"
														[queryParams]="{ requestId: item.requestId }"
														routerLinkActive="is-current-link"
														target="_self"
													>
														<span
															[innerHtml]="item.requestId | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</a>
												</ng-container>
											</ng-container>
										</td>
									</ng-container>
									<ng-container [lowgile-column]="('requestId') + '$$filter'">
										<th mat-header-cell *matHeaderCellDef></th>
									</ng-container>

									<ng-container [lowgile-column]="'name'">
										<th mat-header-cell *matHeaderCellDef>
											<span
												[innerHtml]="'Item name' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
										</th>
										<td
											mat-cell
											*matCellDef="let item; let index = index"
											[attr.data-label]="'Item name'"
										>
											<ng-container
												*lowgileScope="item; as: 'item'; let $scope"
											>
												<ng-container
													*lowgileScope="index; as: 'index'; let $scope"
												>
													<span
														[innerHtml]="_DataTableColumnBlock_cellText_101({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</ng-container>
											</ng-container>
										</td>
									</ng-container>
									<ng-container [lowgile-column]="('name') + '$$filter'">
										<th mat-header-cell *matHeaderCellDef></th>
									</ng-container>

									<ng-container [lowgile-column]="'materials'">
										<th mat-header-cell *matHeaderCellDef>
											<span
												[innerHtml]="'Materials' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
										</th>
										<td
											mat-cell
											*matCellDef="let item; let index = index"
											[attr.data-label]="'Materials'"
										>
											<ng-container
												*lowgileScope="item; as: 'item'; let $scope"
											>
												<ng-container
													*lowgileScope="index; as: 'index'; let $scope"
												>
													<span
														[innerHtml]="_DataTableColumnBlock_cellText_106({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</ng-container>
											</ng-container>
										</td>
									</ng-container>
									<ng-container [lowgile-column]="('materials') + '$$filter'">
										<th mat-header-cell *matHeaderCellDef></th>
									</ng-container>

									<ng-container [lowgile-column]="'request.status'">
										<th mat-header-cell *matHeaderCellDef>
											<span
												[innerHtml]="'Request status' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
										</th>
										<td
											mat-cell
											*matCellDef="let item; let index = index"
											[attr.data-label]="'Request status'"
										>
											<ng-container
												*lowgileScope="item; as: 'item'; let $scope"
											>
												<ng-container
													*lowgileScope="index; as: 'index'; let $scope"
												>
													<span
														[innerHtml]="_DataTableColumnBlock_cellText_105({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</ng-container>
											</ng-container>
										</td>
									</ng-container>
									<ng-container
										[lowgile-column]="('request.status') + '$$filter'"
									>
										<th mat-header-cell *matHeaderCellDef></th>
									</ng-container>
								</lowgile-table>
							</div>
						</ng-container>
					</ng-template>
				</Orders-MainLayout>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
